module.exports = __webpack_public_path__ + "static/media/16.cc109bfb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/16.mp3
// module id = 492
// module chunks = 0